/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React, {PureComponent} from 'react'
import {View} from '@instructure/ui-view'

import CreatorEventGroup from './CreatorEventGroup'
import * as propTypes from './propTypes'

export default class AuditTrail extends PureComponent {
  static propTypes = {
    auditTrail: propTypes.auditTrail.isRequired,
  }

  render() {
    // @ts-expect-error
    const {creatorEventGroups} = this.props.auditTrail

    return (
      <View as="div" id="assessment-audit-trail" data-testid="assessment-audit-trail">
        {/* @ts-expect-error */}
        {creatorEventGroups.map(group => (
          <CreatorEventGroup key={group.creator.key} creatorEventGroup={group} />
        ))}
      </View>
    )
  }
}
